import { Outlet } from "react-router-dom";

import { RAIL_CHIUSA, SideRail } from "@/components/SideRail";
import { TopNav } from "@/components/TopNav";
import { VediComeBanner } from "@/components/VediComeBanner";

/**
 * Guscio del portale: barra laterale fissa + header + contenuto.
 *
 * Il margine sinistro è pari alla barra **chiusa**, non a quella aperta: quando
 * si allarga in hover ci passa sopra e il contenuto non si muove. È il vincolo
 * che viene dal tabellone di M3 (11 colonne + il dock di Aida da 420px). Solo lo
 * spillo — che qui non entra, perché la barra è `fixed` — cambia ciò che si vede,
 * e lo fa per scelta esplicita dell'utente.
 */
export function RootLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SideRail />

      <div className="flex min-h-screen flex-col" style={{ marginLeft: RAIL_CHIUSA }}>
        <TopNav />
        <VediComeBanner />

        <main className="flex-1">
          <Outlet />
        </main>

        <footer className="border-t py-4">
          <div className="mx-auto max-w-7xl px-6 text-xs text-muted-foreground">
            G&amp;G Nextgen S.r.l. — software proprietario · Mister Pet S.p.A.
          </div>
        </footer>
      </div>
    </div>
  );
}
